const config = {
    api: {
        base: 'https://skeleton',
    },
};

export default config;
